import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[appNoSpace]'
})
export class NoSpaceDirective {
    private allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Delete', 'Enter', 'Escape', 'Home', 'End'];

    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        if (this.allowedKeys.includes(event.key)) { return; }
        const regex = /^[a-zA-Z0-9]$/;
        if (!regex.test(event.key)) {
            event.preventDefault();
        }
    }

    @HostListener('paste', ['$event'])
    onPaste(event: ClipboardEvent) {
        const clipboardData = event.clipboardData || (window as any)['clipboardData'];
        const pastedInput = clipboardData.getData('text');
        // Only allow pasted content that consists entirely of alphanumeric characters
        if (!/^[a-zA-Z0-9]*$/.test(pastedInput)) {
            event.preventDefault();
        }
    }
}